import { Component, HostBinding } from '@angular/core'
import { Router } from '@angular/router'
import { VenueService } from './../../services/venue.service'

@Component({
	selector: 'app-not-found',
	templateUrl: './not-found.component.html',
	styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
	@HostBinding('class') hostClass = 'content__body'
	constructor(private venueService: VenueService, private router: Router) {}

	goBack() {
		let storedVenueId = this.venueService.getVenueId

		if (storedVenueId) {
			this.router.navigate(['/menu/', storedVenueId])
		} else {
			this.router.navigate(['/'])
		}
	}
}
